module.exports = __webpack_public_path__ + "fonts/AvenirRoman.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/AvenirRoman.ttf
// module id = 475
// module chunks = 12